import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import config from 'devextreme/core/config'
import deMessages from 'devextreme/localization/messages/es.json'
import { locale, loadMessages } from 'devextreme/localization'
import { FormContextProvider } from './context/FormContext'
import bgDesktop from './assets/img/BG-Form-Impacta-Web.png'
import bgMobile from './assets/img/BG-Form-Impacta-Mobile.png'
import { useMediaQuery } from '@react-hooks-library/core'
import { Toaster } from 'react-hot-toast'
import './assets/css/dx.material.custom-scheme.css'
import './assets/css/tailwind.css'
import './assets/css/index.css'

import 'animate.css'

config({
  editorStylingMode: 'underlined',
  defaultCurrency: 'COP',
  defaultDateType: 'date',
  defaultUseCurrencyAccountingStyle: true
})

loadMessages(deMessages)
locale(navigator.language)

const root = ReactDOM.createRoot(document.getElementById('root'))

const Background = () => {
  const isLargeScreen = useMediaQuery('(min-width: 640px)')

  return <div id='bg' className='bg-cover bg-no-repeat bg-bottom fixed top-0 left-0 w-full h-full' style={{ zIndex: -1, backgroundImage: `url(${isLargeScreen ? bgDesktop : bgMobile})` }} />
}

root.render(
  <>
    <Background />
    <Toaster position='bottom-right' />
    <FormContextProvider>
      <div className='container xl:pl-80 xl:p-44 xl:px-60 md:p-28 px-16 pt-24 flex flex-col justify-start items-center h-screen w-screen md:block'>
        <App />
      </div>
    </FormContextProvider>
  </>
)
